import { Component } from "@angular/core";
import { ToastModule } from "primeng/toast";

@Component({
  selector: "jni-toastr",
  standalone: true,
  imports: [ToastModule],
  templateUrl: "./jni-toastr.component.html",
})
export class JniToastrComponent {}
